export default "__VITE_ASSET__CMPN$O1D__"